module.exports = "<div style=\"width: 500px;\">\n  {{help}}\n</div>\n"